import React, { useState } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge";
import MobileBottomMenu from "../components/MobileBottomMenu";

const SECTION_IDS = ["laban", "petra-foods", "mcdonalds-kuwait", "farmers-market"];
const SECTION_TITLE_KEYS = {
  laban: "laban",
  "petra-foods": "petra_foods",
  "mcdonalds-kuwait": "mcdonalds_kuwait",
  "farmers-market": "farmers_market",
};

const Laban = () => {
  const { lang } = useLang();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("laban");

  const sectionIndex = SECTION_IDS.indexOf(activeSection);
  const safeSectionIndex = sectionIndex >= 0 ? sectionIndex : 0;

  const handlePrevSection = () => {
    const prevIndex = (safeSectionIndex - 1 + SECTION_IDS.length) % SECTION_IDS.length;
    setActiveSection(SECTION_IDS[prevIndex]);
  };
  const handleNextSection = () => {
    const nextIndex = (safeSectionIndex + 1) % SECTION_IDS.length;
    setActiveSection(SECTION_IDS[nextIndex]);
  };

  const sideNavItems = [
    { id: "go-back", title: translations[lang].go_back, isBack: true },
    { id: "laban", title: translations[lang].laban, isBack: false },
    { id: "petra-foods", title: translations[lang].petra_foods, isBack: false },
    { id: "mcdonalds-kuwait", title: translations[lang].mcdonalds_kuwait, isBack: false },
    { id: "farmers-market", title: translations[lang].farmers_market, isBack: false },
  ];

  const currentSectionTitle =
    SECTION_TITLE_KEYS[activeSection] &&
    translations[lang][SECTION_TITLE_KEYS[activeSection]];

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div
            className="rightSideDiv"
          >
            <div className="navbarDiv">
              <ul>
                {sideNavItems.map((item) => (
                  <li key={item.id}>
                    {item.isBack ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/");
                        }}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="go back"
                          src="./images/left-arrow.png"
                          style={{
                            marginRight: lang === "en" ? "15px" : 0,
                            marginLeft: lang === "ar" ? "15px" : 0,
                            height: "20px",
                            width: "auto",
                            transform: lang === "ar" ? "rotate(180deg)" : undefined,
                          }}
                        />
                        {item.title}
                      </a>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveSection(item.id);
                        }}
                        className={activeSection === item.id ? "active" : ""}
                        style={{ textAlign: lang === "ar" ? "right" : "left" }}
                      >
                        {item.title}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            {activeSection === "laban" && (
              <section
                id="laban"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].laban}
                </h2>
                <div className="labanContentImg">
                  <img className="labanImg" src="./images/brands/Laban.png" alt="Laban" />
                </div>
                <p className="commonpara">
                  {translations[lang].laban_overview}
                </p>
                <a
                  className="commonLink"
                  href="https://drinklaban.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-discover="true"
                  style={{ display: "inline-block", marginBottom: "1.5rem" }}
                >
                  {translations[lang].laban_link}
                </a>
                <p className="commonpara">
                  {translations[lang].laban_description_1}
                </p>
                <p className="commonpara">
                  {translations[lang].laban_challenge}
                </p>
                <p className="commonpara">
                  <span style={{ fontWeight: 800}}>{translations[lang].laban_description_label}</span>
                  {translations[lang].laban_result}
                </p>
              </section>
            )}
            {activeSection === "petra-foods" && (
              <section
                id="petra-foods"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].petra_foods}
                </h2>
                <div className="labanContentImg">
                  <img className="petraImg" src="./images/brands/Petra Foods.png" alt="Laban" />
                </div>
                <p className="commonpara">
                  {translations[lang].petra_foods_overview}
                </p>
                <a
                  className="commonLink"
                  href="https://petrafoods.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-discover="true"
                  style={{ display: "inline-block", marginBottom: "1.5rem" }}
                >
                  {translations[lang].petra_foods_link}
                </a>
                <p className="commonpara">
                  {translations[lang].petra_foods_description_1}
                </p>
                <p className="commonpara">
                  {translations[lang].petra_foods_challenge}
                </p>
                <p className="commonpara">
                  <span style={{ fontWeight: 800}}>{translations[lang].laban_description_label}</span>                  
                  {translations[lang].petra_foods_result}
                </p>
              </section>
            )}
            {activeSection === "mcdonalds-kuwait" && (
              <section
                id="mcdonalds-kuwait"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].mcdonalds_kuwait}
                </h2>
                <div className="labanContentImg">
                  <img className="mcdonaldsImg" src="https://iili.io/BBsJWgf.md.png"/>
                  {/* <img className="mcdonaldsImg" src="https://freeimage.host/i/BBsJWgf" alt="Laban" /> */}
                  {/* <img className="mcdonaldsImg" src="./images/brands/McDonalds.png" alt="Laban" /> */}
                </div>
                <p className="commonpara">
                  {translations[lang].mcdonalds_overview}
                </p>
                <a
                  className="commonLink"
                  href="https://mcdonaldskw.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-discover="true"
                  style={{ display: "inline-block", marginBottom: "1.5rem" }}
                >
                  {translations[lang].mcdonalds_link}
                </a>
                <p className="commonpara">
                  {translations[lang].mcdonalds_description_1}
                </p>
                <p className="commonpara">
                  {translations[lang].mcdonalds_challenge}
                </p>
                <p className="commonpara">
                  <span style={{ fontWeight: 800}}>{translations[lang].laban_description_label}</span>
                  {translations[lang].mcdonalds_result}
                </p>
              </section>
            )}
            {activeSection === "farmers-market" && (
              <section
                id="farmers-market"
                className="aboutSection"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <h2 className="aboutSectionTitle">
                  {translations[lang].farmers_market}
                </h2>
                <div className="labanContentImg">
                  {/* <img className="farmersMarketImg" src="./images/brands/Farmers Market.png" alt="Laban" /> */}
                  <img className="farmersMarketImg" src="https://i.imghippo.com/files/QFn7350JI.png" alt="Laban" />
                </div>
                <p className="commonpara">
                  {translations[lang].farmers_market_overview}
                </p>
                <a
                  className="commonLink"
                  href="https://tryfarmersmarket.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-discover="true"
                  style={{ display: "inline-block", marginBottom: "1.5rem" }}
                >
                  {translations[lang].farmers_market_link}
                </a>
                <p className="commonpara">
                  {translations[lang].farmers_market_description_1}
                </p>
                <p className="commonpara">
                  {translations[lang].farmers_market_challenge}
                </p>
                <p className="commonpara">
                  <span style={{ fontWeight: 800}}>{translations[lang].laban_description_label}</span>
                  {translations[lang].farmers_market_result}
                </p>
              </section>
            )}
          </div>
        </div>
      </div>
      <MobileBottomMenu
        title={currentSectionTitle ?? translations[lang].laban}
        withTabs
        sectionIndex={safeSectionIndex}
        sectionCount={SECTION_IDS.length}
        onPrev={handlePrevSection}
        onNext={handleNextSection}
      />
    </Wrapper>
  );
};

export default Laban;
